import { combineReducers } from 'redux';
import { router5Reducer } from 'redux-router5'
import entriesReducer from './entries';
import searchReducer from './search';
import filtersReducer from './filters';
import intialiseSettingsReducer from './initialise-settings';
import cookieDataReducer from './cookieData';
import toggleReducer from './toggle';


export default function createReducer() {
	return combineReducers({
		entries: entriesReducer,
		search: searchReducer,
		filters: filtersReducer,
		settings: intialiseSettingsReducer,
		router: router5Reducer,
		cookieData: cookieDataReducer,
		toggle: toggleReducer
	});
}
